/**
 * Preview Mode: how many table rows show full EUR/tax values before masking.
 * @param {number} totalRows
 * @returns {number}
 */
export function getPreviewVisibleRowCount(totalRows) {
  const n = Math.max(0, Math.floor(Number(totalRows) || 0));
  if (n <= 0) return 0;
  if (n <= 10) return 1;
  if (n <= 50) return 3;
  if (n <= 250) return 5;
  if (n <= 1000) return 7;
  return 10;
}

/**
 * Whether a row's EUR/tax cells should be masked in Preview Mode.
 * @param {number} rowIndex 0-based index in display order
 * @param {number} totalRows
 * @param {boolean} isPreviewMode
 * @returns {boolean}
 */
export function shouldMaskPreviewEurRow(rowIndex, totalRows, isPreviewMode) {
  if (!isPreviewMode) return false;
  const total = Math.max(0, Math.floor(Number(totalRows) || 0));
  if (total <= 0) return false;
  const visible = getPreviewVisibleRowCount(total);
  const idx = Math.max(0, Math.floor(Number(rowIndex) || 0));
  return idx >= visible;
}

/**
 * Whether the table has any masked rows left (for preview notice).
 * @param {number} totalRows
 * @param {boolean} isPreviewMode
 * @returns {boolean}
 */
export function hasPreviewMaskedEurRows(totalRows, isPreviewMode) {
  if (!isPreviewMode) return false;
  const total = Math.max(0, Math.floor(Number(totalRows) || 0));
  if (total <= 0) return false;
  return getPreviewVisibleRowCount(total) < total;
}

/**
 * Whether to show the preview lock separator after this row (last visible sample).
 * @param {number} rowIndex 0-based index in display order
 * @param {number} totalRows
 * @param {boolean} isPreviewMode
 * @returns {boolean}
 */
export function shouldShowPreviewSeparatorAfterRow(rowIndex, totalRows, isPreviewMode) {
  if (!isPreviewMode) return false;
  const total = Math.max(0, Math.floor(Number(totalRows) || 0));
  if (total <= 0) return false;
  const visible = getPreviewVisibleRowCount(total);
  if (visible >= total) return false;
  const idx = Math.max(0, Math.floor(Number(rowIndex) || 0));
  return idx === visible - 1;
}
